import { useState } from "react";

export const FeedbackModal = ({ isOpen, onConfirm, onCancel }) => {
  const [feedback, setFeedback] = useState("");
  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
          <div className="p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Feedback
            </h3>
            <textarea
              className="w-full max-w-md sm:max-w-lg h-28 p-3 rounded-lg border border-gray-300 shadow resize-none"
              placeholder="Write your feedback here..."
              maxLength={200}
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
            />

            <div className="flex justify-end gap-3 mt-3">
              <button
                onClick={onCancel}
                className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={() => onConfirm(feedback)}
                className="px-4 py-2 bg-indigo-500 text-white rounded-lg hover:bg-indigo-600 transition-colors"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
